document.addEventListener("DOMContentLoaded", function() {
  const headings = document.querySelectorAll('.footer-block__heading');
  
  headings.forEach(function(heading) {
    heading.addEventListener('click', function() {
      const ul = this.nextElementSibling;
      ul.style.display = ul.style.display === 'block' ? 'none' : 'block';
    });
  });
});